import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=5df7b1ff&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=5df7b1ff&prod&lang=scss&scoped=true"
import style1 from "./TheSidebar.vue?vue&type=style&index=1&id=5df7b1ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7b1ff",
  null
  
)

export default component.exports